const ISSUE_NAVIGATOR_URL = `/issues/?jql=${encodeURIComponent(
	'created >= -30d order by created DESC',
)}`;

const buildSmartQueryAdvancedSearchUrl = (query: string) =>
	`/secure/QuickSearch.jspa?searchString=${encodeURIComponent(query)}`;

const buildJQLAdvancedIssueUrl = (jql: string) => `/issues/?jql=${jql}`;

const buildJiraAdvancedSearchPath = (query: string) => {
	const trimmedQuery = query.trim();
	if (!trimmedQuery) {
		// If query is empty, we utilise a spa transition with ISSUE_NAVIGATOR_URL
		return query === '' ? ISSUE_NAVIGATOR_URL : buildSmartQueryAdvancedSearchUrl(query);
	}

	return buildJQLAdvancedIssueUrl(`text ~ "${encodeURIComponent(trimmedQuery)}"`);
};

export const buildJiraAdvancedSearchUrl = (query: string, siteUrl?: string) => {
	return new URL(buildJiraAdvancedSearchPath(query), siteUrl ?? '');
};
